
import { useEffect, useState } from 'react'
import { Button, Flex, IconButton, Image, VStack } from '@chakra-ui/react'
import loadingSpinner from 'assets/lottie/loader_wicar.gif'
import { useVehicles } from 'context'
import { VehicleType } from 'context/types'

import CustomPagination from 'components/CustomPagination'
import { CarrouselLeftIcon, CarrouselRightIcon, CheckmarkIcon } from 'components/SVGS'
import VehicleInformation from 'components/VehicleInformation'

import { ShareVehicleInfo } from './ShareVehicleInfo'


const VehicleCarrousel = () => {
  const {
    setVehicle,
    getVehicleLocation,
    vehicleState: { state: { vehicle, vehicles, vehicleLocation,extraLoading }
  } } = useVehicles()

  const [currentSlide, setCurrentSlide] = useState(0)

  const prevSlide = () => setCurrentSlide(s => (s === 0 ? (vehicles.length - 1) : s - 1))

  const nextSlide = () => setCurrentSlide(s => (s === (vehicles.length - 1) ? 0 : s + 1))


  const selectVehicle: (vehicle: VehicleType) => void = (vehicle: VehicleType) => setVehicle(vehicle)

  useEffect(() => {
    const idx = vehicles.findIndex(x => x.id === vehicle?.id)

    if (idx > -1) setCurrentSlide(idx)

    if (vehicle) getVehicleLocation(vehicle.id, false, vehicle.isRestricted)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle, vehicles])

  return (
    <VStack w='full' spacing={5} h='full'>
     { extraLoading  ?
      <VStack alignItems='center' w='100%'>
        <Image
          w={'120px'}
          h={'120px'}
          alt={'loading_wicar'}
          src={loadingSpinner}
        />
      </VStack>
      :
      <>
        <Button
          width='80%'
          height='50px'
          overflow='hidden'
          {...(vehicles[currentSlide] && { onClick: () => selectVehicle(vehicles[currentSlide]) })}
          {...(vehicle === vehicles[currentSlide] && { leftIcon: <CheckmarkIcon size={8} /> })}
        >
          <Flex overflow='hidden'>
            {
              vehicle !== null
                ? vehicle !== vehicles[currentSlide]
                  ? 'Seleccionar vehículo'
                  : 'Vehículo seleccionado'
                : 'Seleccionar vehículo'
            }
          </Flex>
        </Button>
        <Flex w='full' overflow='hidden' pos='relative'>
          <Flex w="full" h='full'>
            <VStack boxSize='full' flex='none' h='300px'>
              <VehicleInformation
                vehicle={vehicles[currentSlide]}
                mileage={vehicleLocation.mileage}
                isOnline={vehicleLocation.isOnline}
              isCarrouselComponent isCenter />
              <VStack flex={1} justifyContent='center' w={'full'} py={0}>
                <Image
                  maxH={'200px'}
                  maxW={'60%'}
                  src={vehicles[currentSlide].mainImageUrl}
                  alt={vehicles[currentSlide].model} />
              </VStack>
            </VStack>
          </Flex>
          {!(currentSlide === 0) &&
            <IconButton aria-label='' variant={'icon'} role='group' pos='absolute' top='50%' left="2" onClick={() => {
              prevSlide()
            }}
              icon={<CarrouselLeftIcon size={10} />} />}
          {!(currentSlide === (vehicles.length - 1)) &&
            <IconButton aria-label='' variant={'icon'} role='group' pos='absolute' top='50%' right="2" onClick={() => {
              nextSlide()
            }}
              icon={<CarrouselRightIcon size={10} />} />}
        </Flex>
        <CustomPagination activeDotIndex={currentSlide} dotsLength={vehicles.length} />
        {vehicle === vehicles[currentSlide] && vehicle.isPremium && vehicle.isOwner && <ShareVehicleInfo />}
      </>
      }
    </VStack>
  )
}

export default VehicleCarrousel
